import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ClienteService} from "../../../modules/cadastro/services/cliente.service";
import {ClienteDetalhes} from "../../models/cliente-detalhes";
import {DetalhesTarefasComponent} from "../detalhes-tarefas/detalhes-tarefas.component";

@Component({
  selector: 'app-detalhes-clientes',
  standalone: false,
  templateUrl: './detalhes-clientes.component.html',
  styleUrl: './detalhes-clientes.component.css'
})
export class DetalhesClientesComponent implements OnInit, OnChanges {
  @Input() id: number;

  clienteDetalhes = new ClienteDetalhes();

  constructor(private clienteService: ClienteService) {

  }

  onAtualizarAtendimentos(): void {
    if (this.id) {
      this.clienteService.buscarDetalhesPorId(this.id).subscribe(result => {
        if (result.sucesso) {
          this.clienteDetalhes = result.dados;
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['id']) {
      this.clienteService.buscarDetalhesPorId(this.id).subscribe(result => {
        if (result.sucesso) {
          this.clienteDetalhes = result.dados;
        }
      });
    }
  }

  ngOnInit(): void {


  }

  formatarDocumento(documento: string, tipoDocumentoDescricao: string): string {
    if (!documento) {
      return '';
    }

    // Remove any non-numeric characters
    const numeroLimpo = documento.replace(/\D/g, '');

    // Format as CPF: 111.111.111-11
    if (tipoDocumentoDescricao && tipoDocumentoDescricao.toUpperCase().includes('CPF')) {
      if (numeroLimpo.length !== 11) {
        return documento; // Return original if not valid CPF length
      }
      return numeroLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    // Format as CNPJ: 11.111.111/1111-11
    if (tipoDocumentoDescricao && tipoDocumentoDescricao.toUpperCase().includes('CNPJ')) {
      if (numeroLimpo.length !== 14) {
        return documento; // Return original if not valid CNPJ length
      }
      return numeroLimpo.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    // Return original if not CPF or CNPJ
    return documento;
  }

  buscarIniciais(nome: string) {
    const palavras = nome.trim().split(" ");
    const iniciais = palavras.map(palavra => palavra.charAt(0).toUpperCase());
    return iniciais.join("");
  }
}
